<div class="btn-header cursor-pointer" id="setting-menu">
	<span> <a (click)="onClickSettings()" title="{{'common_all_SettingMenu' | i18n}}" class="cursor-pointer"><i
				class="material-icons-outlined icon-14 primary-font">settings</i></a> </span>
</div>